import clone from "lodash/cloneDeep"
import forEach from "lodash/forEach"
import map from "lodash/map"
import uniq from "lodash/uniq"
import uniqBy from "lodash/uniqBy"

import Vue from 'vue'

export default {
  getFields: function (fields, values, format) {
    return map(fields, field => {
      const config = clone(field)

      let value = values[config.label]
      if (! value) {
        value = config.default
      }

      if (config.inputType === 'number' || (config.inputType === 'select' && config.type === 'number')) {
        value = parseFloat(value)
      }
      else if (config.inputType === 'exerciseTypes') {
        config.values = uniqBy(format.exercises.map(et => ({
          id: et.exerciseTypeId,
          name: Vue.i18n.t('exercise.type.' + et.exerciseTypeId),
        })), 'id')
        if (value) {
          value = config.values.filter(et => value.includes(et.id))
        } else {
          value = []
        }
      }

      return { config, value }
    })
  },

  getValues: function(customFields) {
    const options = {}
    forEach(customFields, option => {
      const label = option.config.label
      if (option.value !== undefined) {
        let value = option.value
        if (option.config.inputType === 'exerciseTypes') {
          value = uniq(option.value.map(i => i.id))
        }
        else if (option.config.inputType === 'number' || (option.config.inputType === 'select' && option.config.type === 'number')) {
          value = parseFloat(value)
        }

        options[label] = value
      } else if (option.config.inputType === 'copy') {
        const sourceOption = customFields.find(o => o.config.label === option.config.source)
        if (sourceOption?.value) {
          options[label] = sourceOption.value
        }
      }
    })

    console.log('options', options)
    return options
  },
}
